import { SuggestActionIgnoreExpiration } from 'owa-locstrings/lib/strings/suggestactionignoreexpiration.locstring.json';
import { SuggestActionRefreshTheLink } from 'owa-locstrings/lib/strings/suggestactionrefreshthelink.locstring.json';
import loc from 'owa-localize';
import { refreshExpirationDate } from '../actions/publicActions';
import { SharingData } from '../schema/SharingData';
import { SharingTipId } from '../types/sharingTipId';
import { InfoBarCustomAction } from 'owa-info-bar/lib/schema/InfoBarMessageViewState';

export function getExpirationCustomActions(sharingData: SharingData): InfoBarCustomAction[] | null {
    const refreshCustomAction: InfoBarCustomAction = {
        text: loc(SuggestActionRefreshTheLink),
        action: () => {
            refreshExpirationDate(sharingData.id);
        },
    };
    const ignoreCustomAction: InfoBarCustomAction = {
        text: loc(SuggestActionIgnoreExpiration),
        action: () => {
            sharingData.sharingTipsIgnored.push(SharingTipId.linkHasExpired);
            sharingData.sharingTipsIgnored.push(SharingTipId.linkWillExpire);
        },
    };
    return [refreshCustomAction, ignoreCustomAction];
}
